import * as i0 from '@angular/core';
import { HostBinding, Input, ChangeDetectionStrategy, Component, NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorableDirective } from '@tc/interstellar-utilities';
const _c0 = ["*"];
function StlrIconComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.icon, " ");
  }
}
function StlrIconComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
class StlrIconComponent extends ColorableDirective {
  constructor() {
    super(...arguments);
    this.hostClass = true;
    this._size = 'med';
    this._type = 'outline';
    this.button = null;
    this.ariaHidden = true;
    this._icon = '';
  }
  get type() {
    return this._type;
  }
  set type(value) {
    if (!value) return;
    this._type = value;
  }
  get size() {
    return this._size;
  }
  set size(value) {
    if (!value) return;
    this._size = value;
  }
  get innerClass() {
    return `stlr-icon ${this.sizeClass} ${this.typeClass} ${this.colorClass}`;
  }
  get sizeClass() {
    return this._size;
  }
  get typeClass() {
    return this._type === 'outline' ? 'material-symbols-outlined' : 'material-icons';
  }
  get colorClass() {
    return this.color;
  }
  get icon() {
    return this._icon;
  }
  set icon(value) {
    if (!value) return;
    this._icon = value;
  }
  get _isPrefix() {
    return this.positionClass === 'start';
  }
  get _isSuffix() {
    return this.positionClass === 'end';
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵStlrIconComponent_BaseFactory;
      return function StlrIconComponent_Factory(__ngFactoryType__) {
        return (ɵStlrIconComponent_BaseFactory || (ɵStlrIconComponent_BaseFactory = i0.ɵɵgetInheritedFactory(StlrIconComponent)))(__ngFactoryType__ || StlrIconComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrIconComponent,
      selectors: [["stlr-icon"]],
      hostVars: 7,
      hostBindings: function StlrIconComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("aria-hidden", ctx.ariaHidden);
          i0.ɵɵclassProp("stlr-icon", ctx.hostClass)("stlr-form-field--prefix", ctx._isPrefix)("stlr-form-field--suffix", ctx._isSuffix);
        }
      },
      inputs: {
        type: "type",
        size: "size",
        icon: "icon",
        positionClass: "positionClass"
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 3,
      vars: 3,
      template: function StlrIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "span");
          i0.ɵɵconditionalCreate(1, StlrIconComponent_Conditional_1_Template, 1, 1)(2, StlrIconComponent_Conditional_2_Template, 1, 0);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.innerClass);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.icon ? 1 : 2);
        }
      },
      styles: ["[_nghost-%COMP%]{--icon__primary: var(--stlr-color__primary);--icon__secondary: var(--stlr-color__secondary--dark);--icon__info: var(--stlr-color__info);--icon__warn: var(--stlr-color__warn--dark);--icon__error: var(--stlr-color__error);--icon__success: var(--stlr-color__success--dark);--icon__subdued: var(--stlr-color__surface--light);--icon__dark: var(--stlr-color__copy);--icon__light: white;--icon__link: var(--stlr-color__link);--icon__size: var(--font--24);--icon__size-xs: var(--font--14);--icon__size-sml: var(--font--20);--icon__size-med: var(--font--24);--icon__size-lrg: var(--font--32);--icon__size-xl: var(--font--48);display:flex;align-items:center;justify-content:center}:not(a)   [_nghost-%COMP%], :not(button)   [_nghost-%COMP%]{cursor:default}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{font-size:var(--icon__size);height:var(--icon__size);width:var(--icon__size);vertical-align:middle;font-weight:300}[_nghost-%COMP%]   button[_ngcontent-%COMP%], [_nghost-%COMP%]   [stlr-button][_ngcontent-%COMP%], [_nghost-%COMP%]   [stlrButton][_ngcontent-%COMP%]{color:var(--stlr-color__copy)}[_nghost-%COMP%]   span.min[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].min[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].min[_ngcontent-%COMP%]{font-size:var(--icon__size-min);height:var(--icon__size-min);width:var(--icon__size-min)}[_nghost-%COMP%]   span.xxs[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].xxs[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].xxs[_ngcontent-%COMP%]{font-size:var(--icon__size-xxs);height:var(--icon__size-xxs);width:var(--icon__size-xxs)}[_nghost-%COMP%]   span.xs[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].xs[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].xs[_ngcontent-%COMP%]{font-size:var(--icon__size-xs);height:var(--icon__size-xs);width:var(--icon__size-xs)}[_nghost-%COMP%]   span.sml[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].sml[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].sml[_ngcontent-%COMP%]{font-size:var(--icon__size-sml);height:var(--icon__size-sml);width:var(--icon__size-sml)}[_nghost-%COMP%]   span.med[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].med[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].med[_ngcontent-%COMP%]{font-size:var(--icon__size-med);height:var(--icon__size-med);width:var(--icon__size-med)}[_nghost-%COMP%]   span.lrg[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].lrg[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].lrg[_ngcontent-%COMP%]{font-size:var(--icon__size-lrg);height:var(--icon__size-lrg);width:var(--icon__size-lrg)}[_nghost-%COMP%]   span.xl[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].xl[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].xl[_ngcontent-%COMP%]{font-size:var(--icon__size-xl);height:var(--icon__size-xl);width:var(--icon__size-xl)}[_nghost-%COMP%]   span.xxl[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].xxl[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].xxl[_ngcontent-%COMP%]{font-size:var(--icon__size-xxl);height:var(--icon__size-xxl);width:var(--icon__size-xxl)}[_nghost-%COMP%]   span.max[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].max[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].max[_ngcontent-%COMP%]{font-size:var(--icon__size-max);height:var(--icon__size-max);width:var(--icon__size-max)}[_nghost-%COMP%]   span.primary[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].primary[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].primary[_ngcontent-%COMP%]{color:var(--icon__primary)}[_nghost-%COMP%]   span.secondary[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].secondary[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].secondary[_ngcontent-%COMP%]{color:var(--icon__secondary)}[_nghost-%COMP%]   span.info[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].info[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].info[_ngcontent-%COMP%]{color:var(--icon__info)}[_nghost-%COMP%]   span.error[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].error[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].error[_ngcontent-%COMP%]{color:var(--icon__error)}[_nghost-%COMP%]   span.warn[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].warn[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].warn[_ngcontent-%COMP%]{color:var(--icon__warn)}[_nghost-%COMP%]   span.success[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].success[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].success[_ngcontent-%COMP%]{color:var(--icon__success)}[_nghost-%COMP%]   span.gray[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].gray[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].gray[_ngcontent-%COMP%]{color:var(--icon__gray)}[_nghost-%COMP%]   span.surface[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].surface[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].surface[_ngcontent-%COMP%]{color:var(--icon__surface)}[_nghost-%COMP%]   span.subdued[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].subdued[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].subdued[_ngcontent-%COMP%]{color:var(--icon__subdued)}[_nghost-%COMP%]   span.dark[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].dark[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].dark[_ngcontent-%COMP%]{color:var(--icon__dark)}[_nghost-%COMP%]   span.light[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].light[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].light[_ngcontent-%COMP%]{color:var(--icon__light)}[_nghost-%COMP%]   span.link[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlr-button].link[_ngcontent-%COMP%], [_nghost-%COMP%]   button[stlrButton].link[_ngcontent-%COMP%]{color:var(--icon__link)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrIconComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-icon',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<span [class]=\"innerClass\">\n  @if (icon) {\n    {{ icon }}\n  } @else {\n    <ng-content></ng-content>\n  }\n\n</span>\n",
      styles: [":host{--icon__primary: var(--stlr-color__primary);--icon__secondary: var(--stlr-color__secondary--dark);--icon__info: var(--stlr-color__info);--icon__warn: var(--stlr-color__warn--dark);--icon__error: var(--stlr-color__error);--icon__success: var(--stlr-color__success--dark);--icon__subdued: var(--stlr-color__surface--light);--icon__dark: var(--stlr-color__copy);--icon__light: white;--icon__link: var(--stlr-color__link);--icon__size: var(--font--24);--icon__size-xs: var(--font--14);--icon__size-sml: var(--font--20);--icon__size-med: var(--font--24);--icon__size-lrg: var(--font--32);--icon__size-xl: var(--font--48);display:flex;align-items:center;justify-content:center}:not(a) :host,:not(button) :host{cursor:default}:host span{font-size:var(--icon__size);height:var(--icon__size);width:var(--icon__size);vertical-align:middle;font-weight:300}:host button,:host [stlr-button],:host [stlrButton]{color:var(--stlr-color__copy)}:host span.min,:host button[stlr-button].min,:host button[stlrButton].min{font-size:var(--icon__size-min);height:var(--icon__size-min);width:var(--icon__size-min)}:host span.xxs,:host button[stlr-button].xxs,:host button[stlrButton].xxs{font-size:var(--icon__size-xxs);height:var(--icon__size-xxs);width:var(--icon__size-xxs)}:host span.xs,:host button[stlr-button].xs,:host button[stlrButton].xs{font-size:var(--icon__size-xs);height:var(--icon__size-xs);width:var(--icon__size-xs)}:host span.sml,:host button[stlr-button].sml,:host button[stlrButton].sml{font-size:var(--icon__size-sml);height:var(--icon__size-sml);width:var(--icon__size-sml)}:host span.med,:host button[stlr-button].med,:host button[stlrButton].med{font-size:var(--icon__size-med);height:var(--icon__size-med);width:var(--icon__size-med)}:host span.lrg,:host button[stlr-button].lrg,:host button[stlrButton].lrg{font-size:var(--icon__size-lrg);height:var(--icon__size-lrg);width:var(--icon__size-lrg)}:host span.xl,:host button[stlr-button].xl,:host button[stlrButton].xl{font-size:var(--icon__size-xl);height:var(--icon__size-xl);width:var(--icon__size-xl)}:host span.xxl,:host button[stlr-button].xxl,:host button[stlrButton].xxl{font-size:var(--icon__size-xxl);height:var(--icon__size-xxl);width:var(--icon__size-xxl)}:host span.max,:host button[stlr-button].max,:host button[stlrButton].max{font-size:var(--icon__size-max);height:var(--icon__size-max);width:var(--icon__size-max)}:host span.primary,:host button[stlr-button].primary,:host button[stlrButton].primary{color:var(--icon__primary)}:host span.secondary,:host button[stlr-button].secondary,:host button[stlrButton].secondary{color:var(--icon__secondary)}:host span.info,:host button[stlr-button].info,:host button[stlrButton].info{color:var(--icon__info)}:host span.error,:host button[stlr-button].error,:host button[stlrButton].error{color:var(--icon__error)}:host span.warn,:host button[stlr-button].warn,:host button[stlrButton].warn{color:var(--icon__warn)}:host span.success,:host button[stlr-button].success,:host button[stlrButton].success{color:var(--icon__success)}:host span.gray,:host button[stlr-button].gray,:host button[stlrButton].gray{color:var(--icon__gray)}:host span.surface,:host button[stlr-button].surface,:host button[stlrButton].surface{color:var(--icon__surface)}:host span.subdued,:host button[stlr-button].subdued,:host button[stlrButton].subdued{color:var(--icon__subdued)}:host span.dark,:host button[stlr-button].dark,:host button[stlrButton].dark{color:var(--icon__dark)}:host span.light,:host button[stlr-button].light,:host button[stlrButton].light{color:var(--icon__light)}:host span.link,:host button[stlr-button].link,:host button[stlrButton].link{color:var(--icon__link)}\n"]
    }]
  }], null, {
    hostClass: [{
      type: HostBinding,
      args: ['class.stlr-icon']
    }],
    type: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    ariaHidden: [{
      type: HostBinding,
      args: ['attr.aria-hidden']
    }],
    icon: [{
      type: Input
    }],
    positionClass: [{
      type: Input
    }],
    _isPrefix: [{
      type: HostBinding,
      args: ['class.stlr-form-field--prefix']
    }],
    _isSuffix: [{
      type: HostBinding,
      args: ['class.stlr-form-field--suffix']
    }]
  });
})();
class StlrIconModule {
  static {
    this.ɵfac = function StlrIconModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrIconModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StlrIconModule,
      declarations: [StlrIconComponent],
      imports: [CommonModule],
      exports: [StlrIconComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrIconModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [StlrIconComponent],
      exports: [StlrIconComponent]
    }]
  }], null, null);
})();
class IconTranslationService {
  getIconForColor(color) {
    switch (color) {
      case 'success':
        return 'done';
      case 'error':
        return 'error';
      case 'warn':
        return 'error';
      default:
        return color;
    }
  }
  static {
    this.ɵfac = function IconTranslationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconTranslationService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IconTranslationService,
      factory: IconTranslationService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconTranslationService, [{
    type: Injectable
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { IconTranslationService, StlrIconComponent, StlrIconModule };
